// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, schema de busca, catálogo e o
// carregador da tela. Outro módulo usa a `public.ts` (A06).
export { DISCOUNT_PATH, discountScreen } from './discount.screen';
export { discountSearch } from './discount.search';
export { loadDiscountMessages } from './discount.catalog';

/** A tela da rota (`DiscountRouteScreen`), por `lazyScreen`. */
export const loadDiscountScreens = () => import('./discount.page');

/** O guia da tela para o Luy (U46), sob demanda. */
export const loadDiscountGuides = () => import('./discount.guide');
